<form [formGroup]="formItem">
  <div  style="display: flex; justify-content: space-around;">

    <mat-form-field class="example-full-width">
      <mat-label>ITEM</mat-label>
        <input matInput placeholder="Item" formControlName="item" name="item" >
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>DESCRIPCION</mat-label>
        <input matInput placeholder="Descripcion" formControlName="descripcion" name="descripcion" >
        <!-- <span class="text-danger" *ngIf="formItem.get('descripcion')?.hasError('required')">
          segsfeefs
        </span> -->
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>CANTIDAD</mat-label>
        <input matInput placeholder="Cantidad" formControlName="cantidad" name="cantidad" >
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>PRECIO UNITARIO</mat-label>
        <input matInput placeholder="Precio x Unidad" formControlName="precioUnidad" name="precioUnidad" >
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>INAFECTO</mat-label>
      <mat-select formControlName="inafecto">
        <mat-option *ngFor="let obj of lstInafecto" [value]="obj">
          {{ obj }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="example-full-width" *ngIf="estadoIgv">
      <mat-label>IGV</mat-label>
      <mat-select formControlName="igv" >
        <mat-option *ngFor="let obj of lstIgv" [value]="obj">
          {{ obj }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  
  </div>
</form>
<div style="margin-top: 0.2rem;display: flex;justify-content: center">
  <button mat-raised-button class="buttonPrimary" (click)="goBack()" > Agregar </button>
</div>
